import { motion } from "framer-motion";
import { GraduationCap, BookOpen, CreditCard } from "lucide-react";

import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
 

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/bb518d17-6e14-4c6a-a24e-f5c3198d7bb0" +
  "?include=field_imagen_portada.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

// Variantes para el contenedor principal (Efecto cascada/stagger)
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2, // Retardo entre la aparición del título y cada bloque
    },
  },
};

// Variantes para los elementos individuales (Aparición suave desde abajo)
const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut",
    },
  },
};

function SemanasInternacionalesEscuelaNegocios() {
  const DataDisplay = ({ data }) => (
    <motion.div
      className="max-w-6xl m-auto text-center py-24 px-4"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }} // Animación se ejecuta cuando entra en pantalla
    >
      {/* Título / Texto Portada */}
      <motion.div
        variants={itemVariants}
        className="mb-8
             /* Estilos para badges o subtítulos dentro de data.texto_portada */
            [&_h4]:inline-flex
            [&_h4]:items-center
            [&_h4]:bg-slate-50
            [&_h4]:text-[#004270]
            [&_h4]:backdrop-blur-md
            [&_h4]:border
            [&_h4]:border-white/20
            [&_h4]:rounded-full
            [&_h4]:px-5
            [&_h4]:py-2
            [&_h4]:text-xs
            [&_h4]:font-semibold
            [&_h4]:tracking-wide
            [&_h4]:uppercase
            [&_h4]:shadow-sm"
        dangerouslySetInnerHTML={{
          __html: data.texto_portada,
        }}
      />

   
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
       <motion.div
          variants={itemVariants}
          whileHover={{ y: -6, transition: { duration: 0.2 } }}
          className="p-6 rounded-lg bg-[#febe10]/20 transition-shadow hover:shadow-lg"
          dangerouslySetInnerHTML={{
            __html: data.bloque2,
          }}
        />
        <motion.div
          variants={itemVariants}
          whileHover={{ y: -6, transition: { duration: 0.2 } }} // Microinteracción al pasar el cursor
          className="p-6 rounded-lg bg-[#004270]/10 transition-shadow hover:shadow-lg"
          dangerouslySetInnerHTML={{
            __html: data.bloque1,
          }}
        />
 
    
 
        <motion.div
          variants={itemVariants}
          whileHover={{ y: -6, transition: { duration: 0.2 } }}
          className="p-6 rounded-lg bg-gray-100 dark:bg-zinc-800/50 transition-shadow hover:shadow-lg"
          dangerouslySetInnerHTML={{
            __html: data.bloque3,
          }}
        />
      </div>
    </motion.div>
  );

  return (
    <DataFetcherTemplateHome url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome>
  );
}

export default SemanasInternacionalesEscuelaNegocios;